import { Model } from 'dva'
import { TelephonyService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'
import { Worker } from './types'

const Workers: Model = {
  namespace: 'workers',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let workers = yield select((state: any) => state.workers.list)
        if (!(workers.length > 0 && useCache)) {
          workers = yield call(TelephonyService.telephonyWorkersList, {})
          yield put({ type: 'modifyList', payload: workers })
        }
        onSuccess(workers)
      } catch (err: any) {
        FailureHandler('Error fetching workers', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let worker = yield select((state: any) =>
          state.workers.list.find((worker: Worker) => worker.id === id)
        )
        if (!worker) {
          worker = yield call(TelephonyService.telephonyWorkersRetrieve, { id: id })
        }
        yield put({ type: 'modifyList', payload: worker })
        onSuccess(worker)
      } catch (err) {
        FailureHandler('Could not find the worker!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonyWorkersCreate, { requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a worker', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonyWorkersPartialUpdate, {
          id: id,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a worker', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(TelephonyService.telephonyWorkersDestroy, { id: id })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a worker', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: Worker) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: Worker) => !action.payload.map((p: Worker) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: Worker) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetWorkers(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default Workers
